module.exports = "/lucky-balls/img/infobox/info_Box_033.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_033.png
// module id = 1098
// module chunks = 0